<template lang="pug">
.card.mb-0
  template(v-if="redirectAddPromo")
    addpromo(@back="refresh()")
  template(v-else)  
    .card-header
      .row.w-100
        .form-group.col-md-3.col-2
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              i.fa.fa-lg.fa-search
            DebounceInput(required autofocus type="text" size="sm" v-model="search" :placeholder="$t('message.search_by_id')" @enter="getPromoList(true)")
        .form-group.col-md-3.col-2.mb-1
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              span {{ $t('ui.status') }}
            b-form-select(v-model="promoAccStatus" @change="getPromoList(true)" :disabled="loading" size="sm")
              option(value=0) {{ $t('ui.all') }}
              option(value=1) {{ $t('ui.active') }}
              option(value=-1) {{ $t('ui.inactive') }}
        .form-group.col-md-6.col-8.mb-1
          SubmitButton(
            :loading="loading"
            icon="fa fa-search"
            :text="$t('ui.search')"
            type="button"
            @click="getPromoList(true)"
            variant="primary"
            size="sm"
          )
        .form-group.col-12(v-if="isEditAccess")
          b-button(type="button" variant="info" size="sm" @click="redirectAddPromo = true")
            i.fa.fa-lg.fa-plus
            span.ml-1 {{ $t("ui.combine.add_promo") }}
    .card-body
      .row
        .col-10.mb-1
          b-pagination.float-left(
            size="sm"
            hide-ellipsis
            :total-rows="totalRow"
            :per-page="getPageSize"
            v-model="currentPage"
            @input="changedPage($event)")
        .col-2.mb-1
          b-input-group(:prepend="$t('ui.page_size')" size="sm")
            b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
        .col-12 
          .clusterize-scroll.table-responsive
            table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
              thead.thead-light
                tr
                  th.text-center(width="3%")
                    span #
                  th.sortable(width="10%" @click="sortOrder('promotion_id')")
                    span(:title="$t('ui.id')") {{ $t('ui.id') }}
                    .float-right
                      i(:class="changeSortKey('promotion_id')")
                  //- th.sortable(width="8%" @click="sortOrder('promotion_name')")
                  //-   span(:title="$t('ui.name')") {{ $t('ui.name') }}
                  //-   .float-right
                  //-     i(:class="changeSortKey('promotion_name')")
                  th.sortable(width="8%" @click="sortOrder('claim_type')")
                    span(:title="$t('ui.claim_type')") {{ $t('ui.claim_type') }}
                    .float-right
                      i(:class="changeSortKey('claim_type')")
                  th.sortable.text-right(width="7%" @click="sortOrder('min_deposit')")
                    span(:title="$t('ui.min_deposit')") {{ $t('ui.min_deposit') }}
                    .float-right
                      i(:class="changeSortKey('min_deposit')")
                  th.sortable.text-right(width="7%" @click="sortOrder('bonus_rate')")
                    span(:title="$t('ui.bonus_rate')") {{ $t("ui.bonus_rate") }}
                    .float-right
                      i(:class="changeSortKey('bonus_rate')")
                  th.sortable.text-right(width="7%" @click="sortOrder('max_bonus')")
                    span(:title="$t('ui.max_bonus')") {{ $t("ui.max_bonus") }}
                    .float-right
                      i(:class="changeSortKey('max_bonus')")
                  th.sortable.text-right(width="7%" @click="sortOrder('rollover')")
                    span(:title="$t('ui.rollover')") {{ $t("ui.rollover") }}
                    .float-right
                      i(:class="changeSortKey('rollover')")
                  th.sortable(width="7%" @click="sortOrder('criteria')")
                    span(:title="$t('ui.criteria')") {{ $t("ui.criteria") }}
                    .float-right
                      i(:class="changeSortKey('criteria')")
                  th.sortable.text-right(width="5%")
                    span(:title="$t('ui.claim_limit')") {{ $t("ui.claim_limit") }}
                  th(width="10%")
                    span(:title="$t('ui.banner')") {{ $t("ui.banner") }}
                  th.text-center.sortable(width="6%" @click="sortOrder('status')")
                    span(:title="$t('ui.status')") {{ $t("ui.status") }}
                    .float-right
                      i(:class="changeSortKey('status')")
                  th.text-center(width="6%")
                    span(:title="$t('ui.sequence')") {{ $t("ui.sequence") }}
                  th.text-right.sortable(width="9%" @click="sortOrder('start_date')")
                    span(:title="$t('ui.start_date')") {{ $t("ui.start_date") }}
                    .float-right
                      i(:class="changeSortKey('start_date')")
                  th.text-right.sortable(width="9%" @click="sortOrder('end_date')")
                    span(:title="$t('ui.end_date')") {{ $t("ui.end_date") }}
                    .float-right
                      i(:class="changeSortKey('end_date')")
                  //- th.text-center(width="6%")
                  //-   span(:title="$t('ui.action')") {{ $t("ui.action") }}
              tbody.clusterize-content
                tr(v-if="promoAccountList.length == 0")
                  td(colspan="14").text-center
                    span {{ $t('message.no_data_available') }}
                template(v-for="(item, index) in promoAccountList")
                  tr(:class="$helpers.rowClassBitPromo(item.status)")
                    td.text-center
                      span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                    td
                      span.d-block(:title="item.promotion_id") {{ item.promotion_id }}
                      span.small(:title="item.promotion_name") {{ item.promotion_name }}
                      .float-right
                        i.fa.fa-lg(:title="$t('ui.detail')" size="sm" @click="onOffDetail(item)" :class="currId == item.promotion_id ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                    //- td
                    //-   span(:title="item.promotion_name") {{ item.promotion_name }}
                    td
                      span(:title="item.claim_type") {{ item.claim_type }}
                    td.text-right
                      span(:title="$n(item.min_deposit, 'currency')") {{ $n(item.min_deposit, 'currency') }}
                    td.text-right
                      span(:title="$n(item.bonus_rate, 'currency')") {{ $n(item.bonus_rate, 'currency') }}
                    td.text-right
                      span(:title="$n(item.max_bonus, 'currency')") {{ $n(item.max_bonus, 'currency') }}
                    td.text-right
                      span(:title="item.rollover") {{ item.rollover }}
                    td
                      span(:title="item.criteria") {{ item.criteria }}
                    td.text-right
                      span(:title="item.claim_limit") {{ item.claim_limit }}
                    td.p-1
                      template(v-if="isEditAccess")
                        .promo-banner-summary(
                          role="button"
                          tabindex="0"
                          :aria-label="$t('ui.combine.edit_promotion_banner')"
                          :title="promoBannerPillTitle(item)"
                          @click="openPromoBannerModal(item)"
                          @keydown.enter.prevent="openPromoBannerModal(item)"
                          @keydown.space.prevent="openPromoBannerModal(item)"
                        )
                          .promo-banner-summary__main
                            .promo-banner-summary__row
                              span.promo-banner-summary__label {{ $t("ui.slot_view") }}
                              span.promo-banner-summary__value(
                                :class="{ 'promo-banner-summary__value--empty': !promoBannerIdPresent(item.banner_id1) }"
                              ) {{ promoBannerPillValue(item.banner_id1) }}
                            .promo-banner-summary__row
                              span.promo-banner-summary__label {{ $t("ui.non_slot_view") }}
                              span.promo-banner-summary__value(
                                :class="{ 'promo-banner-summary__value--empty': !promoBannerIdPresent(item.banner_id2) }"
                              ) {{ promoBannerPillValue(item.banner_id2) }}
                          //- i.fa.fa-pencil-alt.promo-banner-summary__icon(:aria-hidden="true") 
                      template(v-else)
                        .promo-banner-summary.promo-banner-summary--readonly
                          .promo-banner-summary__main
                            .promo-banner-summary__row
                              span.promo-banner-summary__label {{ $t("ui.slot_view") }}
                              span.promo-banner-summary__value(
                                :class="{ 'promo-banner-summary__value--empty': !promoBannerIdPresent(item.banner_id1) }"
                              ) {{ promoBannerPillValue(item.banner_id1) }}
                            .promo-banner-summary__row
                              span.promo-banner-summary__label {{ $t("ui.non_slot_view") }}
                              span.promo-banner-summary__value(
                                :class="{ 'promo-banner-summary__value--empty': !promoBannerIdPresent(item.banner_id2) }"
                              ) {{ promoBannerPillValue(item.banner_id2) }}
                    td
                      div.d-flex.justify-content-center.align-items-center
                        label.custom-switch
                          input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="!isEditAccess ? null : changedStatus(item, $event)" :disabled="!isEditAccess")
                          span.custom-switch-indicator
                    td
                      b-form-select.text-center(v-model="item.seq" @change="!isEditAccess ? null : changedSeq(item, $event)" size="sm" :disabled="!isEditAccess")
                        option(value=0 disabled) 0
                        option(v-for="index in promoAccountListLength" :key="index") {{ index }}
                        option(v-if="promoAccountListLength < 100" :key="100") 100
                    td.text-right
                      span(:title="$moment(item.start_date).format('YYYY-MM-DD') + ', ' + item.start_time") {{ $moment(item.start_date).format('YYYY-MM-DD') }}
                      br
                      span(:title="$moment(item.start_date).format('YYYY-MM-DD') + ', ' + item.start_time") {{ item.start_time }}
                    td.text-right
                      template(v-if="isEditAccess")
                        a.text-primary.font-weight-bold.text-decoration-none(href="javascript:void(0)" @click="onUpdateEndDate(item)")
                          span(:title="$moment(item.end_date).format('YYYY-MM-DD')") {{ $moment(item.end_date).format("YYYY-MM-DD") }}
                          br
                          span(:title="$moment(item.end_date).format('YYYY-MM-DD')") {{ item.end_time }}
                      template(v-else)
                        span(:title="$moment(item.end_date).format('YYYY-MM-DD')") {{ $moment(item.end_date).format("YYYY-MM-DD") }}
                        br
                        span(:title="$moment(item.end_date).format('YYYY-MM-DD')") {{ item.end_time }}
                  tr(v-if="isShowDetail == true && currId == item.promotion_id")
                    td(colspan="14")
                      table.table.table-sm.table-bordered.table-striped.table-hover
                        thead.thead-dark
                          tr
                            th.text-center(width="5%")
                              span(:title="$t('ui.vip')") {{ $t("ui.vip") }}
                            th.text-left(width="10%")
                              span(:title="$t('ui.promotion_type')") {{ $t("ui.promotion_type") }}
                              template(v-if="isEditAccess")
                                span.float-right(v-if="['CUSTOM'].includes(item.promotion_type)")
                                  a.fa.fa-lg.fa-edit.text-warning(href="javascript:void(0)" @click="onGetCustomMemberList(item)" :title="$t('ui.edit')")
                            th.text-center.sortable(width="10%")
                              span(:title="$t('ui.withhold_bonus')") {{ $t("ui.withhold_bonus") }}
                            th.sortable.text-right(width="10%")
                              span(:title="$t('ui.withhold_amount')") {{ $t("ui.withhold_amt") }}
                            th.sortable.text-right(width="11%")
                              span(:title="$t('ui.max_withdraw_amount')") {{ $t("ui.max_withdraw_amt") }}
                            th.sortable.text-right(width="12%")
                              span(:title="$t('ui.max_withdraw_multiple')") {{ $t("ui.max_withdraw_multiple") }}
                            th.text-center(width="6%")
                              span(:title="$t('ui.monday')") {{ $t("ui.short.monday") }}
                            th.text-center(width="6%")
                              span(:title="$t('ui.tuesday')") {{ $t("ui.short.tuesday") }}
                            th.text-center(width="6%")
                              span(:title="$t('ui.wednesday')") {{ $t("ui.short.wednesday") }}
                            th.text-center(width="6%")
                              span(:title="$t('ui.thursday')") {{ $t("ui.short.thursday") }}
                            th.text-center(width="6%")
                              span(:title="$t('ui.friday')") {{ $t("ui.short.friday") }}
                            th.text-center(width="6%")
                              span(:title="$t('ui.saturday')") {{ $t("ui.short.saturday") }}
                            th.text-center(width="6%")
                              span(:title="$t('ui.sunday')") {{ $t("ui.short.sunday") }}
                        tbody.clusterize-content
                          tr
                            td.text-center
                              span(:title="item.vip_list") {{ item.vip_list }}
                            td.text-left
                              span(:title="item.promotion_type") {{ item.promotion_type }}
                            td.text-center
                              span
                                i(:class="{'fas fa-check text-info': item.withhold_bonus, 'fas fa-times text-warning': !item.withhold_bonus  }")
                            td.text-right
                              span(:title="$n(item.withhold_amount, 'currency')") {{ $n(item.withhold_amount, 'currency') }}
                            td.text-right
                              span(:title="$n(item.max_withdraw_amount, 'currency')") {{ $n(item.max_withdraw_amount, 'currency') }}
                            td.text-right
                              span(:title="$n(item.max_withdraw_multiple, 'currency')") {{ $n(item.max_withdraw_multiple, 'currency') }}
                            td.text-center
                              span
                                i(:class="{'fas fa-check text-info': item.monday, 'fas fa-times text-warning': !item.monday  }")
                            td.text-center
                              span
                                i(:class="{'fas fa-check text-info': item.tuesday, 'fas fa-times text-warning': !item.tuesday  }")
                            td.text-center
                              span
                                i(:class="{'fas fa-check text-info': item.wednesday, 'fas fa-times text-warning': !item.wednesday  }")
                            td.text-center
                              span
                                i(:class="{'fas fa-check text-info': item.thursday, 'fas fa-times text-warning': !item.thursday  }")
                            td.text-center
                              span
                                i(:class="{'fas fa-check text-info': item.friday, 'fas fa-times text-warning': !item.friday  }")
                            td.text-center
                              span
                                i(:class="{'fas fa-check text-info': item.saturday, 'fas fa-times text-warning': !item.saturday  }")
                            td.text-center
                              span
                                i(:class="{'fas fa-check text-info': item.sunday, 'fas fa-times text-warning': !item.sunday  }")
                      table.table.table-sm.table-bordered.table-striped.table-hover
                        thead.thead-dark
                          tr
                            th(width="25%")
                              span(:title="$t('ui.provider_list')") {{ $t("ui.provider_list") }}
                              span.float-right(v-if="isEditAccess")
                                a.fa.fa-lg.fa-edit.text-warning(href="javascript:void(0)" @click="onEditProviderList(item)" :title="$t('ui.edit')")
                            //- th(width="15%")
                            //-   span(:title="$t('ui.payment_option')") {{ $t("ui.payment_option") }}
                            //-   span.float-right(v-if="isEditAccess")
                            //-     a.fa.fa-lg.fa-edit.text-warning(href="javascript:void(0)" @click="onEditPaymentOptionList(item)" :title="$t('ui.edit')")
                            th.text-center(width="6%")
                              span(:title="$t('ui.bonus_rate_1')") {{ $t("ui.bonus_rate_1") }}
                            th.text-center(width="6%")
                              span(:title="$t('ui.bonus_rate_2')") {{ $t("ui.bonus_rate_2") }}
                            th.text-center(width="6%")
                              span(:title="$t('ui.bonus_rate_3')") {{ $t("ui.bonus_rate_3") }}
                            th.text-center(width="6%")
                              span(:title="$t('ui.bonus_rate_4')") {{ $t("ui.bonus_rate_4") }}
                            th.text-center(width="6%")
                              span(:title="$t('ui.bonus_rate_5')") {{ $t("ui.bonus_rate_5") }}
                            th.text-center(width="6%")
                              span(:title="$t('ui.bonus_rate_6')") {{ $t("ui.bonus_rate_6") }}
                            th.text-center(width="6%")
                              span(:title="$t('ui.bonus_rate_7')") {{ $t("ui.bonus_rate_7") }}
                            th.text-center(width="6%")
                              span(:title="$t('ui.bonus_rate_8')") {{ $t("ui.bonus_rate_8") }}
                            th.text-center(width="6%")
                              span(:title="$t('ui.bonus_rate_9')") {{ $t("ui.bonus_rate_9") }}
                            th.text-center(width="6%")
                              span(:title="$t('ui.bonus_rate_10')") {{ $t("ui.bonus_rate_10") }}
                        tbody.clusterize-content
                          tr
                            td
                              template(v-if="item.provider_list")
                                a.float-right.pointer(v-if="item.provider_list.split(',').map(p => p.trim()).length > 5" @click="showPAll = !showPAll")
                                  i.fa(:class="showPAll ? 'fa-minus' : 'fa-plus'")
                                b-badge.mr-1.mb-1(
                                  v-for="(provider, i) in (showPAll ? item.provider_list.split(',').map(p => p.trim()) : item.provider_list.split(',').map(p => p.trim()).slice(0, 5))"
                                  :key="provider"
                                  variant="secondary"
                                )
                                  | {{ provider }}
                              template(v-else)
                                b-badge {{ $t('ui.all') }}
                            //- td
                            //-   span(:title="item.payment_option_list") {{ item.payment_option_list ? item.payment_option_list : $t('ui.all') }}
                            //- td
                            //-   span(:title="item.payment_gateway_list") {{ item.payment_gateway_list ? item.payment_gateway_list : $t('ui.all') }}
                            td.text-center
                              span(:title="item.bonus_rate_1") {{ item.bonus_rate_1 }}
                            td.text-center
                              span(:title="item.bonus_rate_2") {{ item.bonus_rate_2 }}
                            td.text-center
                              span(:title="item.bonus_rate_3") {{ item.bonus_rate_3 }}
                            td.text-center
                              span(:title="item.bonus_rate_4") {{ item.bonus_rate_4 }}
                            td.text-center
                              span(:title="item.bonus_rate_5") {{ item.bonus_rate_5 }}
                            td.text-center
                              span(:title="item.bonus_rate_6") {{ item.bonus_rate_6 }}
                            td.text-center
                              span(:title="item.bonus_rate_7") {{ item.bonus_rate_7 }}
                            td.text-center
                              span(:title="item.bonus_rate_8") {{ item.bonus_rate_8 }}
                            td.text-center
                              span(:title="item.bonus_rate_9") {{ item.bonus_rate_9 }}
                            td.text-center
                              span(:title="item.bonus_rate_10") {{ item.bonus_rate_10 }}

    editpromobanner(ref="editpromobanner" :page-loading="loading" @banner-updated="getPromoList" @failed="handleFailed")
    editpromoprovider(ref="editpromoprovider" :item="editSelectedPromo" @clicked="afterEditProviderList" @failed="handleFailed")
    editpromopaymentoption(ref="editpromopaymentoption" :item="editSelectedPromo" @clicked="afterEditPaymentOptionList" @failed="handleFailed")
    getcustommemberlist(ref="getcustommemberlist" :item="editSelectedPromo" @failed="handleFailed")
    editpromoenddate(ref="editpromoenddate" :item="selectedPromo" @clicked="afterEdit" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import editpromoprovider from "@/components/promo/editPromoProvider.vue";
import editpromopaymentoption from "@/components/promo/editPromoPaymentOption.vue";
import getcustommemberlist from "@/components/promo/getCustomMemberList.vue";
import addpromo from "@/components/promo/addPromo.vue";
import editpromoenddate from "@/components/promo/editPromoEndDate.vue";
import editpromobanner from "@/components/promo/editPromoBanner.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editpromoprovider,
    editpromopaymentoption,
    getcustommemberlist,
    addpromo,
    editpromoenddate,
    editpromobanner
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currentPage: 1,
    totalRow: 0,
    sortKey: "promotion_id",
    sortType: "asc",
    search: "",
    promoAccountList: [],
    currId: null,
    isShowDetail: false,
    promoAccStatus: 1,
    editSelectedPromo: null,
    redirectAddPromo: false,
    maxSeq: 0,
    selectedPromo: null,
    showPAll: false
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizePromo;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_promotion");
    },
    promoAccountListLength() {
      if (this.promoAccountList) {
        if(this.maxSeq > this.promoAccountList.length) {
          return this.maxSeq;
        } else {
          return this.promoAccountList.length;
        }
      } else {
        return 0;
      }
    },
  },
  mounted: function() {  },
  methods: {
    onUpdateEndDate(e) {
      this.selectedPromo = e;
      this.$refs.editpromoenddate.$refs.editPromoEndDate.show();
    },
    afterEdit: function() {
      this.getPromoList();
      this.$helpers.showDialog(this.$t("ui.edit_promotion_end_date"), this.$t("message.success"), "success");
    },
    promoBannerPillValue(val) {
      return this.promoBannerIdPresent(val) ? String(val) : "–";
    },
    promoBannerPillTitle(item) {
      return `${this.$t("ui.slot_view")}: ${this.promoBannerPillValue(item.banner_id1)} | ${this.$t("ui.non_slot_view")}: ${this.promoBannerPillValue(item.banner_id2)}`;
    },
    openPromoBannerModal(item) {
      this.$refs.editpromobanner.open(item);
    },
    promoBannerIdPresent(val) {
      if (val == null || val === "") return false;
      if (typeof val === "string" && val.trim() === "") return false;
      return true;
    },
    refresh() {
      this.redirectAddPromo = false;
      this.getPromoList(true);
    },
    onOffDetail(item) {
      this.showPAll = false
      if (this.isShowDetail == true) {
        if (this.currId == item.promotion_id) {
          this.isShowDetail = false;
          this.currId = null;
        } else {
          this.isShowDetail = false;
          this.currId = null;
          this.isShowDetail = true;
          this.currId = item.promotion_id;
        }
      } else {
        this.isShowDetail = true;
        this.currId = item.promotion_id;
      }
    },
    sortOrder(key, type) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getPromoList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    onGetCustomMemberList(e) {
      this.editSelectedPromo = e;
      this.$refs.getcustommemberlist.$refs.getCustomMemberList.show();
    },
    onEditProviderList(e) {
      this.editSelectedPromo = e;
      this.$refs.editpromoprovider.$refs.editPromoProvider.show();
    },
    onEditPaymentOptionList(e) {
      this.editSelectedPromo = e;
      this.$refs.editpromopaymentoption.$refs.editPromoPaymentOption.show();
    },
    afterEditProviderList: function(item) {
      this.getPromoList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_promo_provider_list"), this.$t("message.success"), "success");
    },
    afterEditPaymentOptionList: function(item) {
      this.getPromoList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_promo_payment_option"), this.$t("message.success"), "success");
    },
    getPromoList: function(isSearch) {
      this.isShowDetail = false;
      this.showPAll = false
      this.currId = null;
      let url = config.promotionListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize,
      };

      if (this.search.trim() != '') {
        json.promotion_id = this.search.trim();
      }

      if (this.promoAccStatus == 1) {
        json.promo_status = true;
      } else if (this.promoAccStatus == -1) {
        json.promo_status = false;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.promoAccountList = response.data.dt;
                this.totalRow = this.promoAccountList.length > 0 ? this.promoAccountList[0].totalrows : 0;
                if(this.promoAccountList.length > 0) {
                  // Filter out objects with seq < 100, then find the max seq value
                  const maxSeq = this.promoAccountList
                      .filter(item => item.seq < 100) // Keep only items with seq < 100
                      .reduce((max, item) => Math.max(max, item.seq), -Infinity); // Find the maximum seq

                  this.maxSeq = maxSeq;
                } else {
                  this.maxSeq = 0;
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedSeq: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_promotion_seq_confirm", { id: item.promotion_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmSeq(item, eventStatus);
          } else {
            this.getPromoList();
          }
        });
    },
    confirmSeq: function(item, seq) {
      let url = config.promotionUpdateSeqUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        promotion_id: item.promotion_id,
        seq: seq
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getPromoList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getPromoList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    changedStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_promo_status_confirm", { name: item.promotion_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmStatus: function(item, status) {
      let url = config.promotionStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        promotion_id: item.promotion_id,
        new_status: status
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getPromoList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getPromoList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSizePromo", pageSize);
      this.currentPage = 1;
      this.getPromoList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getPromoList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style scoped>
.promo-banner-summary {
  cursor: pointer;
  display: flex;
  align-items: stretch;
  gap: 0.35rem;
  width: 100%;
  max-width: 100%;
  padding: 0.32rem 0.4rem 0.35rem 0.45rem;
  text-align: left;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 0.2rem;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}
.promo-banner-summary:hover {
  background-color: #fff;
  border-color: #b8bdc2;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.promo-banner-summary:focus {
  outline: none;
  border-color: #63b3ed;
  box-shadow: 0 0 0 2px rgba(66, 153, 225, 0.35);
}
.promo-banner-summary--readonly {
  cursor: default;
  background-color: #fcfcfc;
}
.promo-banner-summary--readonly:hover {
  background-color: #fcfcfc;
  border-color: #dee2e6;
  box-shadow: none;
}
.promo-banner-summary__main {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.18rem;
  line-height: 1.28;
}
.promo-banner-summary__row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.35rem;
  font-size: 0.73rem;
}
.promo-banner-summary__label {
  flex: 0 1 auto;
  min-width: 0;
  color: #5a6268;
  font-weight: 600;
}
.promo-banner-summary__label::after {
  content: ":";
  margin-left: 0.06rem;
  font-weight: 500;
  color: #868e96;
}
.promo-banner-summary__value {
  flex: 0 0 auto;
  max-width: 52%;
  font-weight: 700;
  color: #212529;
  font-variant-numeric: tabular-nums;
  text-align: right;
  word-break: break-all;
}
.promo-banner-summary__value--empty {
  font-weight: 600;
  color: #868e96;
}
.promo-banner-summary__icon {
  flex: 0 0 auto;
  align-self: center;
  font-size: 0.75rem;
  color: #6c757d;
  opacity: 0.9;
  padding: 0.1rem 0 0.1rem 0.1rem;
}
.promo-banner-summary:hover .promo-banner-summary__icon {
  color: #348fe2;
  opacity: 1;
}
</style>
